"use client";

import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["enabled"],
  _excluded2 = ["target"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import f, { Fragment as g, createContext as E, useContext as T, useEffect as R, useMemo as c, useRef as A, useState as G } from "react";
import { createPortal as H } from "react-dom";
import { useEvent as L } from '../../hooks/use-event.js';
import { useIsoMorphicEffect as x } from '../../hooks/use-iso-morphic-effect.js';
import { useOnUnmount as O } from '../../hooks/use-on-unmount.js';
import { useOwnerDocument as _ } from '../../hooks/use-owner.js';
import { useServerHandoffComplete as h } from '../../hooks/use-server-handoff-complete.js';
import { optionalRef as F, useSyncRefs as P } from '../../hooks/use-sync-refs.js';
import { usePortalRoot as U } from '../../internal/portal-force-root.js';
import { env as C } from '../../utils/env.js';
import { forwardRefWithAs as m, render as d } from '../../utils/render.js';
function D(p) {
  var r = U(),
    l = T(v),
    e = _(p),
    _G = G(function () {
      var t;
      if (!r && l !== null) return (t = l.current) != null ? t : null;
      if (C.isServer) return null;
      var u = e == null ? void 0 : e.getElementById("headlessui-portal-root");
      if (u) return u;
      if (e === null) return null;
      var a = e.createElement("div");
      return a.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a);
    }),
    _G2 = _slicedToArray(_G, 2),
    o = _G2[0],
    n = _G2[1];
  return R(function () {
    o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
  }, [o, e]), R(function () {
    r || l !== null && n(l.current);
  }, [l, n, r]), o;
}
var M = g,
  N = m(function (r, l) {
    var e = r,
      o = A(null),
      n = P(F(function (i) {
        o.current = i;
      }), l),
      u = _(o),
      a = D(o),
      _G3 = G(function () {
        var i;
        return C.isServer ? null : (i = u == null ? void 0 : u.createElement("div")) != null ? i : null;
      }),
      _G4 = _slicedToArray(_G3, 1),
      t = _G4[0],
      s = T(y),
      b = h();
    return x(function () {
      !a || !t || a.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a.appendChild(t));
    }, [a, t]), x(function () {
      if (t && s) return s.register(t);
    }, [s, t]), O(function () {
      var i;
      !a || !t || (t instanceof Node && a.contains(t) && a.removeChild(t), a.childNodes.length <= 0 && ((i = a.parentElement) == null || i.removeChild(a)));
    }), b ? !a || !t ? null : H(d({
      ourProps: {
        ref: n
      },
      theirProps: e,
      slot: {},
      defaultTag: M,
      name: "Portal"
    }), t) : null;
  });
function S(p, r) {
  var l = P(r),
    _p$enabled = p.enabled,
    e = _p$enabled === void 0 ? !0 : _p$enabled,
    o = _objectWithoutProperties(p, _excluded);
  return e ? f.createElement(N, _objectSpread(_objectSpread({}, o), {}, {
    ref: l
  })) : d({
    ourProps: {
      ref: l
    },
    theirProps: o,
    slot: {},
    defaultTag: M,
    name: "Portal"
  });
}
var j = g,
  v = E(null);
function W(p, r) {
  var l = p.target,
    e = _objectWithoutProperties(p, _excluded2),
    n = {
      ref: P(r)
    };
  return f.createElement(v.Provider, {
    value: l
  }, d({
    ourProps: n,
    theirProps: e,
    defaultTag: j,
    name: "Popover.Group"
  }));
}
var y = E(null);
function ee() {
  var p = T(y),
    r = A([]),
    l = L(function (n) {
      return r.current.push(n), p && p.register(n), function () {
        return e(n);
      };
    }),
    e = L(function (n) {
      var u = r.current.indexOf(n);
      u !== -1 && r.current.splice(u, 1), p && p.unregister(n);
    }),
    o = c(function () {
      return {
        register: l,
        unregister: e,
        portals: r
      };
    }, [l, e, r]);
  return [r, c(function () {
    return function (_ref) {
      var u = _ref.children;
      return f.createElement(y.Provider, {
        value: o
      }, u);
    };
  }, [o])];
}
var I = m(S),
  J = m(W),
  te = Object.assign(I, {
    Group: J
  });
export { te as Portal, J as PortalGroup, ee as useNestedPortals };